<app-plain-shell [customerSpaceId]="customerSpaceId">
  <h1>{{ 'home.title' | translate }}</h1>
  <nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="start" color="primary" class="home-tabs" [tabPanel]="navPanel">
    <a
      mat-tab-link
      [routerLink]="['/', 'home', 'customer-spaces']"
      routerLinkActive
      #rlaCustomerSpaces="routerLinkActive"
      [active]="rlaCustomerSpaces.isActive"
    >
      {{ 'customer-spaces.title' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/', 'home', 'projects']"
      routerLinkActive
      #rlaProjects="routerLinkActive"
      [active]="rlaProjects.isActive"
    >
      {{ 'customer-spaces.customer-space-list.actions.projects' | translate }}
    </a>
    <a mat-tab-link [routerLink]="['/', 'home', 'tasks']" routerLinkActive #rlaTasks="routerLinkActive" [active]="rlaTasks.isActive">
      {{ 'customer-spaces.customer-space-list.actions.tasks' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #navPanel>
    <router-outlet />
  </mat-tab-nav-panel>
</app-plain-shell>
